import React, { useEffect, useRef, useState } from 'react';
import {
  Config,
  PixelStreaming
} from '@epicgames-ps/lib-pixelstreamingfrontend-ue5.6';

export const PixelStreamingWrapper = ({ initialSettings }) => {
  const videoParent = useRef(null);
  const [pixelStreaming, setPixelStreaming] = useState();
  const [clickToPlayVisible, setClickToPlayVisible] = useState(false);
  const [fatalError, setFatalError] = useState(null);

  // Remove Epic overlay if present (brute force)
  function removeEpicOverlay() {
    const overlays = document.querySelectorAll('div[style*="z-index: 9999999"]');
    overlays.forEach(node => node.remove());
    // Sometimes Epic changes the overlay style/text
    document.querySelectorAll('div').forEach(node => {
      if (node.textContent && node.textContent.includes('Uncaught runtime errors')) {
        node.remove();
      }
    });
  }

  // Patch getStats to prevent calling on closed/null peer connections
  function patchGetStats(streaming) {
    try {
      const ctrl = streaming.webRtcController;
      if (ctrl && ctrl.getStats && !ctrl.__patched) {
        const originalGetStats = ctrl.getStats.bind(ctrl);
        ctrl.getStats = function (...args) {
          // Defensive: only call if peer connection is healthy
          if (!ctrl._peerConnection || ctrl._peerConnection.connectionState === "closed") {
            // Just *silently* return; don't display error
            return;
          }
          try {
            return originalGetStats(...args);
          } catch (e) {
            // Now only display error if it's unexpected during a live session
            console.warn("WebRTC getStats error suppressed:", e);
            // Optionally: set error here if you want, but this is rare
            return;
          }
        };
        ctrl.__patched = true;
      }
    } catch (e) {
      // Do nothing
    }
  }

  useEffect(() => {
    let streaming;
    if (videoParent.current) {
      try {
        const config = new Config({ initialSettings });
        streaming = new PixelStreaming(config, {
          videoElementParent: videoParent.current
        });

        // PATCH: Harden getStats
        patchGetStats(streaming);

        streaming.addEventListener('playStreamRejected', () => {
          setClickToPlayVisible(true);
        });

        streaming.addEventListener('error', (evt) => {
          setFatalError("Une erreur de streaming est survenue. Veuillez réessayer.");
          removeEpicOverlay();
        });

        streaming.addEventListener('disconnect', (evt) => {
          setFatalError("La connexion au serveur de streaming a été interrompue.");
          removeEpicOverlay();
        });

        // Also try to patch if webRtcController changes
        if (streaming.webRtcController) patchGetStats(streaming);

        setPixelStreaming(streaming);

      } catch (err) {
        setFatalError("Erreur de lancement du streaming interactif.");
        removeEpicOverlay();
      }

      // Cleanup
      return () => {
        try {
          streaming?.disconnect();
        } catch (err) {}
        removeEpicOverlay();
      };
    }
  }, [initialSettings]);

  if (fatalError) {
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(30,0,0,0.85)',
          color: '#fff',
          fontSize: 22,
          borderRadius: 12,
        }}
      >
        {fatalError}
        <button
          style={{
            marginLeft: 24,
            background: "#2563eb",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            padding: "8px 18px",
            fontWeight: "bold",
            cursor: "pointer"
          }}
          onClick={() => {
            setFatalError(null);
            // Optionally reload or re-init here
          }}
        >
          Réessayer
        </button>
      </div>
    );
  }

  return (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
      <div
        ref={videoParent}
        style={{
          width: '100%',
          height: '100%',
        }}
      />
      {clickToPlayVisible && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            zIndex: 100,
            background: 'rgba(0,0,0,0.75)'
          }}
          onClick={() => {
            pixelStreaming?.play();
            setClickToPlayVisible(false);
          }}
        >
          <div style={{ color: '#fff', fontSize: 22 }}>Click to play</div>
        </div>
      )}
    </div>
  );
};